<template>
  <v-dialog :model-value="show" :max-width="maxWidth" @update:model-value="$emit('update:show', $event)">
    <v-card :style="{ minWidth: minWidth + 'px' }">
      <v-card-title class="font-weight-bold px-5 py-4 d-flex align-center justify-space-between" :style="headerStyle">
        <div class="d-flex align-center" style="gap: 12px">
          <!-- Font Awesome icon -->
          <i
            v-if="icon && (icon.startsWith('fa') || icon.includes('fa-'))"
            :class="icon"
            :style="{ color: iconColor, fontSize: iconSize + 'px' }"
          />
          <!-- Material Design icon -->
          <v-icon v-else-if="icon && icon.startsWith('mdi')" :color="iconColor" :size="iconSize">
            {{ icon }}
          </v-icon>
          <span>{{ title }}</span>
        </div>
        <v-icon @click="handleClose" color="black" size="28" style="cursor: pointer">mdi-close</v-icon>
      </v-card-title>

      <v-container class="pa-5">
        <v-row>
          <!-- Main message appears first -->
          <v-col cols="12">
            <div class="text-h6">
              {{ message }}
            </div>
          </v-col>

          <!-- Optional additional content slot appears after message -->
          <v-col v-if="$slots.default" cols="12" class="mt-2">
            <slot />
          </v-col>

          <v-col
            cols="12"
            class="mt-6 d-flex"
            :class="[$vuetify.display.xs ? 'flex-column' : cancelText ? 'justify-end' : 'justify-center']"
            style="gap: 12px"
          >
            <UiButton v-if="cancelText" :variant="cancelVariant" :size="buttonSize" @click="handleCancel">
              {{ cancelText }}
            </UiButton>
            <UiButton :variant="confirmVariant" :size="buttonSize" :disabled="confirmDisabled" @click="handleConfirm">
              {{ confirmText }}
            </UiButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import { Button as UiButton } from './index.js';

export default defineComponent({
  name: 'ConfirmationModal',

  components: {
    UiButton
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: '#FFC627'
    },
    iconSize: {
      type: String,
      default: '48'
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    confirmVariant: {
      type: String,
      default: 'gold'
    },
    cancelVariant: {
      type: String,
      default: 'dark-outline'
    },
    buttonSize: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [String, Number],
      default: '720'
    },
    minWidth: {
      type: [String, Number],
      default: '460'
    },
    headerStyle: {
      type: String,
      default: 'background-color: #fec627; font-size: 20px;'
    }
  },

  emits: ['update:show', 'confirm', 'cancel'],

  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },

    handleCancel() {
      this.$emit('cancel');
      this.$emit('update:show', false);
    },

    handleClose() {
      this.$emit('cancel');
      this.$emit('update:show', false);
    }
  }
});
</script>

<style scoped>
.text-h6 {
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.75rem;
}
</style>
